
export enum StoreType {
    "WAREHOUSE" = "WAREHOUSE",
    "STATION" = "STATION"
}
